import { Route, Routes } from 'react-router-dom';
import { Header } from './components/Header';
import { Footer } from './components/Footer';
import { Landing } from './pages/Landing';
import { Pricing } from './pages/Pricing';
import { Catalog } from './pages/Catalog';
import { CertificationDetail } from './pages/CertificationDetail';
import { NotFound } from './pages/NotFound';
import { FAQ } from './pages/FAQ';
import { Privacy } from './pages/legal/Privacy';
import { Terms } from './pages/legal/Terms';
import { Cookies } from './pages/legal/Cookies';
import { Refund } from './pages/legal/Refund';
import { LibroReclamaciones } from './pages/legal/LibroReclamaciones';

export function App() {
  return (
    <div className="flex min-h-screen flex-col">
      <Header />
      <main className="flex-1">
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/precios" element={<Pricing />} />
          <Route path="/certificaciones" element={<Catalog />} />
          <Route path="/certificaciones/:code" element={<CertificationDetail />} />
          <Route path="/faq" element={<FAQ />} />
          <Route path="/privacidad" element={<Privacy />} />
          <Route path="/terminos" element={<Terms />} />
          <Route path="/cookies" element={<Cookies />} />
          <Route path="/reembolso" element={<Refund />} />
          <Route path="/libro-de-reclamaciones" element={<LibroReclamaciones />} />
          <Route path="*" element={<NotFound />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}
